import { createTheme as t } from "./ghl-ui.es855.js";
import r from "./ghl-ui.es1157.js";
import n from "./ghl-ui.es1166.js";
import m from "./ghl-ui.es1160.js";
function p(e) {
  const {
    boxShadow2: o
  } = e;
  return {
    menuBoxShadow: o
  };
}
const c = t({
  name: "Popselect",
  common: r,
  peers: {
    Popover: n,
    InternalSelectMenu: m
  },
  self: p
}), h = c;
export {
  h as default,
  p as self
};
